export type RotationAngle = 90 | 180 | 270

export const ROTATION_ANGLES: readonly RotationAngle[] = [90, 180, 270]

export function rotationLabel(angle: RotationAngle): string {
  return `${angle}°`
}

export const MAX_FILE_MB = 100

const MAX_FILE_BYTES = MAX_FILE_MB * 1024 * 1024

export function validateFileSize(file: File): boolean {
  return file.size <= MAX_FILE_BYTES
}

export function rotatedFilename(originalName: string): string {
  const dotIndex = originalName.lastIndexOf('.')
  const base = dotIndex !== -1 ? originalName.slice(0, dotIndex) : originalName
  return `${base}-rotated.pdf`
}

/**
 * Parse pages spec like "1,3,5-7" into 0-based index array.
 * Returns null on parse error or out-of-range index.
 */
export function parsePageRanges(spec: string, totalPages: number): number[] | null {
  const trimmed = spec.trim()
  if (!trimmed) return null

  const result = new Set<number>()
  for (const part of trimmed.split(',')) {
    const piece = part.trim()
    if (!piece) continue

    const rangeMatch = piece.match(/^(\d+)\s*-\s*(\d+)$/)
    if (rangeMatch) {
      const from = Number(rangeMatch[1])
      const to = Number(rangeMatch[2])
      if (from < 1 || to < 1 || from > totalPages || to > totalPages || from > to) {
        return null
      }
      for (let i = from; i <= to; i++) result.add(i - 1)
      continue
    }

    if (!/^\d+$/.test(piece)) return null
    const n = Number(piece)
    if (n < 1 || n > totalPages) return null
    result.add(n - 1)
  }

  if (result.size === 0) return null
  return Array.from(result).sort((a, b) => a - b)
}
